import { useState, useEffect, useCallback } from 'react';
import { getOnboardingTaskInstances } from '@/services/onboarding.service';

export interface OnboardingTaskInstance {
  _id: string;
  taskId: string;
  title: string;
  description?: string;
  category?: string;
  dueDate?: string;
  status?: 'pending' | 'in_progress' | 'completed';
  weight?: number;
  isActive?: boolean;
  [key: string]: any;
}

export const useOnboardingTaskInstances = (onboardingId?: string) => {
  const [taskInstances, setTaskInstances] = useState<OnboardingTaskInstance[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTaskInstances = useCallback(async () => {
    if (!onboardingId) {
      setTaskInstances([]);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await getOnboardingTaskInstances(onboardingId);
      
      // Handle both array and paginated response formats
      const instancesData = response.data || response;
      
      const finalInstances = Array.isArray(instancesData) ? instancesData : [];
      
      setTaskInstances(finalInstances);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to fetch task instances');
      setTaskInstances([]);
    } finally {
      setLoading(false);
    }
  }, [onboardingId]);

  useEffect(() => {
    fetchTaskInstances();
  }, [fetchTaskInstances]);

  return {
    taskInstances,
    loading,
    error,
    fetchTaskInstances,
  };
}; 